import { fetcher } from "helpers/fetcher";

import { TDeleteActiveVacancyReq, TDeleteActiveVacancyRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteActiveVacancy = async (payload: TDeleteActiveVacancyReq) => {
  return await fetcher<TDeleteActiveVacancyRes, TDeleteActiveVacancyReq>(
    {
      ...ENDPOINT.CORPORATION.DELETE_ACTIVE_VACANCIES,
      url: `${ENDPOINT.CORPORATION.DELETE_ACTIVE_VACANCIES.url}/${payload?.idJobListing}`,
    },
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.DELETE_ACTIVE_VACANCIES.version,
        [API_HEADER.CORP_ID]: payload?.idCorporation,
        [API_HEADER.BU_ID]: payload?.idBusinessUnit,
      },
    }
  );
};

export const mutationDeleteActiveVacancy = async (
  payload: TDeleteActiveVacancyReq
) => {
  return (await deleteActiveVacancy(payload)).data;
};

mutationDeleteActiveVacancy._key = (payload: TDeleteActiveVacancyReq) => [
  ENDPOINT.CORPORATION.DELETE_ACTIVE_VACANCIES.url,
  payload,
];
